import { handleActions } from "redux-actions";
import { COLLECTIONS } from "constants/action-types";
import { List } from "immutable";

interface IState {
    collectionId: string | null;
    contacts: any;
    hasMore: boolean;
    isAdding: boolean;
    isDeleting: boolean;
    isFetching: boolean;
    minIdentity?: string | null;
    result: string[];
    error?: boolean;
}

const initialState: IState = {
    collectionId: null,
    contacts: List(),
    hasMore: false,
    isAdding: false,
    isDeleting: false,
    isFetching: false,
    minIdentity: null,
    result: [],
};

export const collectionPermissions = handleActions(
    {
        [COLLECTIONS.COLLECTION.PERMISSIONS.FETCH.START]: (state: IState): IState => {
            return {
                ...state,
                isFetching: true,
            };
        },
        [COLLECTIONS.COLLECTION.PERMISSIONS.FETCH.COMPLETED]: (state: IState, { payload, error }: any): IState => {
            if (error) {
                return {
                    ...state,
                    isFetching: false,
                };
            }
            return {
                ...state,
                hasMore: false,
                isFetching: false,
                // minIdentity: meta.minIdentity,
                result: payload,
            };
        },
        [COLLECTIONS.COLLECTION.PERMISSIONS.CREATE.START]: (state: IState): IState => {
            return {
                ...state,
                isAdding: true,
            };
        },
        [COLLECTIONS.COLLECTION.PERMISSIONS.CREATE.COMPLETED]: (state: IState, { payload, error }: any): IState => {
            if (error) {
                return {
                    ...initialState,
                    error: payload,
                };
            }
            return {
                ...state,
                result: payload,
                isAdding: false,
            };
        },
        [COLLECTIONS.COLLECTION.PERMISSIONS.DELETE.START]: (state: IState): IState => {
            return {
                ...state,
                isDeleting: true,
            };
        },
        [COLLECTIONS.COLLECTION.PERMISSIONS.DELETE.COMPLETED]: (state: IState, { payload, error }: any): IState => {
            if (error) {
                return {
                    ...initialState,
                    error: payload,
                    isDeleting: false,
                };
            }
            return {
                ...state,
                result: payload,
                isDeleting: false,
            };
        },
        [COLLECTIONS.COLLECTION.PERMISSIONS.UPDATE.COMPLETED]: (state: IState, { payload, error }: any): IState => {
            if (error) {
                return {
                    ...initialState,
                    error: payload,
                };
            }
            return {
                ...state,
            };
        },
        [COLLECTIONS.COLLECTION.PERMISSIONS.CONTACTS.SET]: (state: IState, { payload }: any): IState => {
            return {
                ...state,
                contacts: payload,
            };
        },
    },
    initialState,
);
